const ACTION_TYPE_GET_INTEGRATIONS_LIST_REQUEST = 'ACTION_TYPE_GET_INTEGRATIONS_LIST_REQUEST';
const ACTION_TYPE_GET_INTEGRATIONS_LIST_SUCCESS = 'ACTION_TYPE_GET_INTEGRATIONS_LIST_SUCCESS';
const ACTION_TYPE_GET_INTEGRATIONS_LIST_FAILURE = 'ACTION_TYPE_GET_INTEGRATIONS_LIST_FAILURE';

export {
  ACTION_TYPE_GET_INTEGRATIONS_LIST_REQUEST,
  ACTION_TYPE_GET_INTEGRATIONS_LIST_SUCCESS,
  ACTION_TYPE_GET_INTEGRATIONS_LIST_FAILURE,
};
